module.exports = __webpack_public_path__ + "static/media/bg_1.b1c3d29f.jpg";